import React from "react";
import Heading from "../../typography/Heading";
import Text from "../../typography/Text";
import "./PageHeader.css";

export default function PageHeader({
  title,
  description,
  actions,
  children,
  className = "",
}) {
  return (
    <header className={["page-header", className].filter(Boolean).join(" ")}>
      <div className="page-header__body">
        {title && (
          <Heading as="h1" size="xl">
            {title}
          </Heading>
        )}
        {description && <Text tone="secondary">{description}</Text>}
        {children}
      </div>
      {actions && <div className="page-header__actions">{actions}</div>}
    </header>
  );
}
